import * as React from 'react';

export default function useDebounced<T>(
    value: T,
    ms = 200,
    initialValue?: T,
): T {
    const [debounced, setDebounced] = React.useState(initialValue ?? value);

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebounced(value);
        }, ms);

        return () => {
            clearTimeout(handler);
        };
    }, [value, ms]);

    return debounced;
}
